module.exports = __webpack_public_path__ + "media/src/images/favicon-7252a0b61e5628d7470c6957846b8aa4.ico";